import { cn } from '@change/ds-utils';

import { Button, Text } from '@change/ds-core-ui/next';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

import { ICON_BY_CHANNEL } from './constants';
import { useRoundShareIconButton } from './hooks/useRoundShareIconButton';
import type { RoundShareIconButtonConfig } from './types';

export type { RoundShareIconButtonChannel, RoundShareIconButtonConfig } from './types';

type Props = {
	buttonConfig: RoundShareIconButtonConfig;
	className?: string;
};

export const RoundShareIconButton = ({
	buttonConfig: { ShareAction, label, labelReplacements, channel, successLabel },
	className,
	...rest // for data attributes
}: Props): React.JSX.Element => {
	const IconComponent = ICON_BY_CHANNEL[channel];
	const { data, actions } = useRoundShareIconButton({ label, labelReplacements, successLabel });
	const { translate } = useI18n();
	return (
		<ShareAction onAfterAction={actions.afterShare}>
			<Button
				aria-label={translate(label, labelReplacements)}
				data-testid={`${channel}-share-button`}
				variant="tertiary"
				className={cn(
					'p-0 no-underline [&>div]:flex [&>div]:flex-col [&>div]:items-center [&>div]:justify-center',
					className,
				)}
				{...rest}
			>
				<div className="mt-[5px] flex h-10 w-10 flex-col items-center rounded-full bg-transparent px-0 pb-0">
					{IconComponent}
				</div>
				<Text className="mt-1 block w-full truncate text-xs leading-6">
					<Translate value={data.buttonLabel} replacements={data.buttonLabelReplacement} />
				</Text>
			</Button>
		</ShareAction>
	);
};
